import { getLocaleUtil } from '../../main/utils/locale.util.ts';

const SIGNED_UP_USER_EXISTS_PARTIAL_ERROR_MESSAGE = 'there is already';

export function mapSignUpErrorMessage(error: string): string {
  if (error.toLowerCase().includes(SIGNED_UP_USER_EXISTS_PARTIAL_ERROR_MESSAGE)) {
    return getLocaleUtil().select('auth:signed_up_user_exist');
  }
  return getLocaleUtil().select('auth:sign_up_failed');
}
